import { Component, OnInit, TemplateRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import { ToastNotification } from 'src/app/models/toast-notification.model';

@Component({
  selector: 'app-toast-notification',
  templateUrl: './toast-notification.component.html',
  styleUrls: ['./toast-notification.component.sass']
})
export class ToastNotificationComponent implements OnInit {

  toastDelay = environment.admin.toast_delay;

  constructor(public notificationService: CloudNotificationService) { }

  ngOnInit(): void {
  }

  isTemplate(toast: ToastNotification) {
    return toast.body instanceof TemplateRef;
  }
  
}
